import React, { useEffect, useState, useRef } from 'react';
import { db, auth, storage } from '../firebaseConfig';
import { useParams, useNavigate } from 'react-router-dom';
import { doc, getDoc, collection, addDoc, query, orderBy, onSnapshot, updateDoc, deleteDoc, setDoc } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { useAuthState } from 'react-firebase-hooks/auth';
import '../styles/Chat.css';
import { FiMoreHorizontal } from 'react-icons/fi';
import { FaPaperclip, FaPaperPlane } from 'react-icons/fa';
import { FaPhone } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import imageCompression from 'browser-image-compression';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { app } from '../firebaseConfig'; // 必要に応じて `firebaseConfig` から Firebase App をインポート
import LinkPreviewComponent from '../components/LinkPreview';
import { FaImage } from "react-icons/fa";
// Firebase Functions の初期化をコンポーネントの外に移動
const functions = getFunctions(app, "asia-northeast2");
const getLinkPreview = httpsCallable(functions, "getLinkPreview");

const Chat = () => {
  const { chatId } = useParams();
  const navigate = useNavigate();
  const [user] = useAuthState(auth);
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState('');
  const [chat, setChat] = useState(null);
  const [openMenuId, setOpenMenuId] = useState(null);
  const [participants, setParticipants] = useState({});
  const [selectedImage, setSelectedImage] = useState(null);
  const [editingMessage, setEditingMessage] = useState(null);
  const [expandedImageUrl, setExpandedImageUrl] = useState(null);
  const [headerMenuOpen, setHeaderMenuOpen] = useState(false);
  const [isAgeVerified, setIsAgeVerified] = useState(false);
  const messagesEndRef = useRef(null);
  const textareaRef = useRef(null);
  const [isPaidUser, setIsPaidUser] = useState(false);

  // Firebase Functions の初期化
const extractLinks = (text) => {
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  return text.match(urlRegex) || [];
};
const fetchLinkPreview = async (url) => {
  try {
    const result = await getLinkPreview({ url });
    return result.data; // プレビュー情報を返す
  } catch (error) {
    console.error("Error fetching link preview:", error.message);
    return null;
  }
};



  
  
// Firebase Functions のインスタンスを初期化
const functions = getFunctions(app, "asia-northeast2");


  const MAX_MESSAGE_LENGTH = 500;  // メッセージの最大文字数

  const sanitizeInput = (input) => {
    const div = document.createElement('div');
    div.textContent = input;
    return div.innerHTML;
  };

  const checkPaymentStatus = async () => {
    const payRef = doc(db, 'pay_checked', user.uid);
    try {
      const paySnap = await getDoc(payRef);
      if (paySnap.exists()) {
        const expiration = paySnap.data().expiration?.toDate();
        setIsPaidUser(expiration && expiration > new Date());
      } else {
        setIsPaidUser(false);
      }
    } catch (error) {
      console.error('Error checking payment status:', error.message);
    }
  };
  
  
  const saveBackupConversation = httpsCallable(functions, "saveBackupConversation");

const backupConversation = async (chatId, messages) => {
  try {
    const response = await saveBackupConversation({ chatId, messages });
    if (response.data.success) {
      console.log("Backup saved successfully:", response.data.message);
    } else {
      console.error("Failed to save backup:", response.data.message);
    }
  } catch (error) {
    console.error("Error saving backup:", error.message);
  }
};
  const formatDate = (timestamp) => {
    const date = new Date(timestamp.seconds * 1000); // Firestore TimestampをDateに変換
    return date.toLocaleDateString('ja-JP', { year: 'numeric', month: 'long', day: 'numeric' });
  };
  
  useEffect(() => {
    const handleClickOutside = (event) => {
      // メニューが開いていて、クリックされた要素がメニュー以外の場合
      if (openMenuId && !event.target.closest('.chat_message-menu') && !event.target.closest('.chat_message-options')) {
        setOpenMenuId(null); // メニューを閉じる
      }
    };
  
    document.addEventListener('click', handleClickOutside);
  
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [openMenuId]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // メニューが開いていて、クリックされた要素がメニュー以外の場合
      if (headerMenuOpen && !event.target.closest('.header_menu') && !event.target.closest('.header_menu-dropdown')) {
        setHeaderMenuOpen(false); // メニューを閉じる
      }
    };
  
    document.addEventListener('click', handleClickOutside);
  
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [headerMenuOpen]);
  
  

  const scrollToBottom = () => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };
  const previousDateRef = useRef(null); // useRefでpreviousDateを管理

  useEffect(() => {
    const initializeChat = async () => {
      if (chatId && user) {
        try {
          await checkAgeVerification();
          await checkPaymentStatus(); // ← これを追加
          console.log('isPaidUser after check:', isPaidUser);
          await fetchChat();
          const unsubscribeMessages = await fetchMessages();

          return () => {
            if (unsubscribeMessages) {
              unsubscribeMessages();
            }
          };
        } catch (error) {
          console.error('Error initializing chat:', error.message);
        }
      }
    };

    initializeChat();
  }, [chatId, user]);

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const checkAgeVerification = async () => {
    const ageVerificationRef = doc(db, 'age_verification_checked', user.uid);
    try {
      const ageVerificationSnap = await getDoc(ageVerificationRef);
      setIsAgeVerified(ageVerificationSnap.exists());
    } catch (error) {
      console.error('Error checking age verification:', error.message);
    }
  };

  const fetchChat = async () => {
    try {
      const docRef = doc(db, 'chats', chatId);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setChat(docSnap.data());
        const participantsData = {};
        await Promise.all(docSnap.data().participants.map(async (participantId) => {
          const participantRef = doc(db, 'members', participantId);
          const participantSnap = await getDoc(participantRef);
          if (participantSnap.exists()) {
            const participantData = participantSnap.data();
            participantsData[participantId] = {
              name: participantData.name,
              photoURL: participantData.photoURL, // 画像URLを取得
            };
          }
        }));
        setParticipants(participantsData);
      } else {
        console.error('Chat not found');
      }
    } catch (error) {
      console.error('Error fetching chat:', error.message);
    }
  };
  

  const fetchMessages = async () => {
    try {
      const q = query(collection(db, 'chats', chatId, 'messages'), orderBy('createdAt', 'asc'));
      const unsubscribe = onSnapshot(q, async (querySnapshot) => {
        const messageDocs = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setMessages(messageDocs);

        // 未読メッセージを既読に更新
        await Promise.all(messageDocs.map(async (message) => {
          if (message.sender !== user.uid && !message.read) {
            const messageRef = doc(db, 'chats', chatId, 'messages', message.id);
            await updateDoc(messageRef, { read: true });
          }
        }));

        // 初回レンダリング時に最下部にスクロール
        scrollToBottom();
      });
      return unsubscribe;
    } catch (error) {
      console.error('Error fetching messages:', error.message);
      return null;
    }
  };


  const sendMessage = async () => {
    if (!isAgeVerified) return; // 年齢確認が済んでいない場合はメッセージを送れない
    if ((newMessage.trim() === '' && !selectedImage) || !user) return;
  
    if (newMessage.length > MAX_MESSAGE_LENGTH) {
      console.error('Message too long');
      return;
    }
  
    const sanitizedMessage = sanitizeInput(newMessage);
  
    let imageUrl = null;
    if (selectedImage) {
      const storageRef = ref(storage, `chat_images/${chatId}/${Date.now()}_${selectedImage.name}`);
      try {
        await uploadBytes(storageRef, selectedImage);
        imageUrl = await getDownloadURL(storageRef);
      } catch (error) {
        console.error('Error uploading image:', error.message);
      }
    }
  
    if (editingMessage) {
      try {
        const messageRef = doc(db, 'chats', chatId, 'messages', editingMessage.id);
        await updateDoc(messageRef, {
          text: sanitizedMessage,
          imageUrl: imageUrl || editingMessage.imageUrl,
          editedAt: new Date(),
        });
        setEditingMessage(null);
      } catch (error) {
        console.error('Error editing message:', error.message);
      }
    } else {
      try {
        // 新しいメッセージデータをFirestoreに追加
        const newMessageData = {
          text: sanitizedMessage,
          imageUrl,
          sender: user.uid,
          createdAt: new Date(),
          read: false,
          replyTo: null // 返信機能を削除
        };
  
        const docRef = await addDoc(collection(db, 'chats', chatId, 'messages'), newMessageData);
        
        // Firestoreに保存した新しいメッセージデータのバックアップを保存
        await backupConversation(chatId, [{ ...newMessageData, id: docRef.id }]);
      } catch (error) {
        console.error("Error sending message or saving backup:", error.message);
      }
    }
  
    setNewMessage('');
    setSelectedImage(null);
  };
  
  const handleImageChange = async (e) => {
    if (!isAgeVerified) return; // 年齢確認が済んでいない場合は画像を送れない
    if (e.target.files[0]) {
      const file = e.target.files[0];
  
      // まずプレビュー用に選択された画像を設定
      setSelectedImage(file);
  
      // 画像を圧縮
      const options = {
        maxSizeMB: 0.3,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
      };
  
      try {
        const compressedFile = await imageCompression(file, options);
        setSelectedImage(compressedFile);  // 圧縮された画像を再度設定
      } catch (error) {
        console.error('Error compressing image:', error.message);
      }
    }
  };
  

  const toggleMenu = (messageId) => {
    setOpenMenuId(openMenuId === messageId ? null : messageId);
  };

  const handleEditMessage = (message) => {
    setNewMessage(message.text);
    setEditingMessage(message);
    setOpenMenuId(null);
  };

  const handleDeleteMessage = async (message) => {
    try {
      if (message.imageUrl) {
        const imageRef = ref(storage, message.imageUrl);
        await deleteObject(imageRef);
      }
      const messageRef = doc(db, 'chats', chatId, 'messages', message.id);
      await deleteDoc(messageRef);
      setOpenMenuId(null);
    } catch (error) {
      console.error('Error deleting message:', error.message);
    }
  };

  const handleTextareaChange = (e) => {
    if (e.target.value.length <= MAX_MESSAGE_LENGTH) {
      setNewMessage(e.target.value);
    }
  
    if (textareaRef.current) {
      // 高さを一旦リセットして、入力内容に応じて高さを調整
      textareaRef.current.style.height = 'auto';
  
      // 最大高さを超えないように調整
      const scrollHeight = textareaRef.current.scrollHeight;
      const maxHeight = 150; // 最大高さ
      textareaRef.current.style.height = `${Math.min(scrollHeight, maxHeight)}px`;
    }
  };
  

  const handleImageClick = (imageUrl) => {
    setExpandedImageUrl(imageUrl);
  };

  const handleCloseExpandedImage = () => {
    setExpandedImageUrl(null);
  };

  const handleViewProfile = (participantId) => {
    navigate(`/other_member_profile/${participantId}`);
  };

  const handleHideChat = async () => {
    try {
      const chatRef = doc(db, 'chats', chatId);
      await updateDoc(chatRef, { notdisplay: user.uid });
      navigate('/inbox');
    } catch (error) {
      console.error('Error hiding chat:', error.message);
    }
  };
  

  if (!chat || !user) return <div></div>;

  return (
    <div className="chat_container">

<div className="chat_header">
<div className="header_left">
  <Link to="/inbox" className="back-link-cont-chat">＜</Link>
  <div className="participant-info">
  {chat && chat.participants
    .filter(participant => participant !== user.uid)
    .map(participant => (
      <div key={participant} className="participant-detail">
        <img
          src={participants[participant]?.photoURL || '/default-avatar.png'}
          alt="Participant"
          className="participant-image"
          onClick={() => handleViewProfile(participant)} // プロフィール遷移
        />
        <span className="participant-name">
          {participants[participant]?.name || 'Unknown'}
        </span>
      </div>
    ))}
</div>

</div>

  <div className="header_menu" onClick={() => setHeaderMenuOpen(!headerMenuOpen)}>
    <Link to={`/call/${chatId}`} className="call-link"><FaPhone /></Link>
    <FiMoreHorizontal />
    {headerMenuOpen && (
      <div className="header_menu-dropdown">
        {chat.participants
          .filter(participant => participant !== user.uid)
          .map(participant => (
            <div key={participant}>
              <div className="header_menu-item" onClick={() => handleViewProfile(participant)}>相手のプロフィール</div>
              <div className="header_menu-item" onClick={handleHideChat}>非表示</div>
            </div>
          ))}
      </div>
    )}
  </div>
</div>



<div className="chat_messages">
{(!isAgeVerified || !isPaidUser) && (
    <div className="chat_verification-warning">
      <p>
        {!isAgeVerified && !isPaidUser
          ? "年齢確認および有料プランの登録が必要です。"
          : !isAgeVerified
          ? "年齢確認が必要です。"
          : "課金ユーザー限定機能です。"}
      </p>
    </div>
  )}
  {messages.map((message) => {
    const messageDate = formatDate(message.createdAt);
    const showDateDivider = messageDate !== previousDateRef.current;
    previousDateRef.current = messageDate;

    return (
      <React.Fragment key={message.id}>
        {showDateDivider && (
          <div className="date-divider">
            <span>{messageDate}</span>
          </div>
        )}
        <div className={`chat_message ${message.sender === user.uid ? 'me' : 'other'}`}>
          <div className="chat_message-content">
            {message.text && (
              <>
                <span className="chat_message-text" style={{ whiteSpace: 'pre-wrap' }}>{message.text}</span>
                <div className="link-preview-container">
                  {extractLinks(message.text).map((url) => (
                    <LinkPreviewComponent key={url} url={url} />
                  ))}
                </div>
              </>
            )}
            {message.imageUrl && (
              <img
                src={message.imageUrl}
                alt="sent"
                className="chat_message-image"
                onClick={() => handleImageClick(message.imageUrl)}
              />
            )}
            {message.editedAt && <span className="chat_message-edited">(edited)</span>}
            <div className="chat_message-options" onClick={() => toggleMenu(message.id)}>
              {message.sender === user.uid && (
                <>
                  <FiMoreHorizontal style={{ color: 'gray', position: 'relative', top: '-3px' }} />
                  <div className={`chat_message-menu ${openMenuId === message.id ? 'open' : ''}`}>
                    <div className="chat_message-menu-item" onClick={() => handleEditMessage(message)}>編集</div>
                    <div className="chat_message-menu-item" onClick={() => handleDeleteMessage(message)}>取り消し</div>
                  </div>
                </>
              )}
            </div>
            <span className="chat_message-time">
              {new Date(message.createdAt.seconds * 1000).toLocaleTimeString('ja-JP', {
                hour: '2-digit',
                minute: '2-digit',
              })}
            </span>
          </div>
        </div>
      </React.Fragment>
    );
  })}
  <div ref={messagesEndRef}></div>
</div>


      {isAgeVerified && (
        <div className="chat_input-container">
          {selectedImage && (
            <div className="chat_image-preview">
              <img src={URL.createObjectURL(selectedImage)} alt="Preview" />
              <button onClick={() => setSelectedImage(null)}>取り消し</button>
            </div>
          )}
          <div className="chat_input-wrapper">
            <textarea
              ref={textareaRef}
              value={newMessage}
              onChange={handleTextareaChange}
              placeholder="新しいメッセージの入力"
              className="chat_input"
              rows={1}
              maxLength={MAX_MESSAGE_LENGTH}
              style={{ resize: 'none', overflowY: 'auto' }}
            />
            <label htmlFor="image-upload" className="chat_image-upload">
            <FaImage />
              <input
                id="image-upload"
                type="file"
                accept="image/jpeg,image/jpg,image/png"
                onChange={handleImageChange}
                style={{ display: 'none' }}
              />
            </label>
            <button onClick={sendMessage} className="chat_send-button"><FaPaperPlane /></button>
          </div>
        </div>
      )}
      {expandedImageUrl && (
        <div className="expanded_image_container" onClick={handleCloseExpandedImage}>
          <img src={expandedImageUrl} alt="Expanded" className="expanded_image" />
        </div>
      )}
    </div>
  );
};

export default Chat;
